export const Logo = ({ size = "md" }) => {
  const big = size === "lg";
  return (
    <span className="inline-flex flex-col items-center select-none" data-testid="atas-logo" aria-label="ATAS">
      <span className={`w-px ${big ? "h-14" : "h-4"}`} style={{ background: "linear-gradient(to bottom, transparent, var(--q))" }} />
      <span className={`font-display tracking-[0.12em] leading-none text-ink ${big ? "text-6xl sm:text-7xl" : "text-xl"}`}>ATAS</span>
      <span className={`font-mono-data uppercase text-mute whitespace-nowrap ${big ? "text-[11px] tracking-[0.2em] mt-3" : "hidden sm:block text-[8px] tracking-[0.14em] mt-1"}`} data-testid="atas-fullname">Associate Trainer Akademi Sinergi</span>
    </span>
  );
};
